<template lang="pug">
b-modal#freeCreditManualAssign(
  ref="freeCreditManualAssign"
  :title="$t('ui.combine.free_credit_manual_assign')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.criteria')").mb-0
      VipCriteriaList(
        ref="criteria"
        size="sm"
        type="array"
        :dirty="$v.criteria.$dirty"
        :error="$v.criteria.$error"
        v-model.trim.lazy="$v.criteria.$model"
        :disabled="loading"
        :hideOpt="hideOpt"
      )
      ValidateResult(:value="$v.criteria" :name="$t('ui.criteria')")
    b-form-group(:label="$t('ui.amount')").mb-0
      DebounceInput(
        size="sm"
        ref="base_amount"
        type="text"
        :dirty="$v.base_amount.$dirty"
        :error="$v.base_amount.$error"
        v-model.trim.lazy="$v.base_amount.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.base_amount" :name="$t('ui.amount')")
    b-form-group(:label="$t('ui.rollover')").mb-0
      DebounceInput(
        size="sm"
        ref="rollover"
        type="text"
        :dirty="$v.rollover.$dirty"
        :error="$v.rollover.$error"
        v-model.trim.lazy="$v.rollover.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.rollover" :name="$t('ui.rollover')")
    b-form-group(:label="$t('ui.max_withdraw_amount')").mb-0
      DebounceInput(
        size="sm"
        ref="max_withdraw_amount"
        type="text"
        :dirty="$v.max_withdraw_amount.$dirty"
        :error="$v.max_withdraw_amount.$error"
        v-model.trim.lazy="$v.max_withdraw_amount.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.max_withdraw_amount" :name="$t('ui.max_withdraw_amount')")
    b-form-group(:label="$tc('ui.remark')").mb-0
      DebounceInput(
        ref="remark"
        size="sm"
        type="text"
        :dirty="$v.remark.$dirty"
        :error="$v.remark.$error"
        v-model.trim.lazy="$v.remark.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.remark" :name="$t('ui.remark')")

  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, decimal, integer } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import VipCriteriaList from "@/library/VipCriteriaList";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    VipCriteriaList
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      hideOpt: ['DEPOSIT'],
      remark: "",
      base_amount: "",
      criteria: "",
      rollover: "",
      max_withdraw_amount: "",
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    base_amount: {
      required,
      decimal
    },
    criteria: {
      required
    },
    rollover: {
      required,
      integer
    },
    max_withdraw_amount: {
      required,
      decimal
    },
    remark: {
      required
    }
  },
  methods: {
    resetValue() {
      if (this.criteria == "TURNOVER")
        this.withhold_bonus = false;
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.promotionAssignFreeUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.item.account_id,
          base_amount: this.base_amount,
          criteria: this.criteria,
          rollover: this.rollover,
          max_withdraw_amount: this.max_withdraw_amount,
          remark: this.remark,
          withhold_bonus: 0,
          withhold_amount: 0
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.freeCreditManualAssign.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "free_credit_manual_assign", this.feedback.status);
                  this.$refs.freeCreditManualAssign.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.$v.$reset();
      this.remark = "";
      this.base_amount = ""
      this.criteria = ""
      this.rollover = ""
      this.max_withdraw_amount = ""
    },
    shown: function() {
      this.$refs.criteria.$el.focus();
    }
  }
};
</script>
